import { render, staticRenderFns } from "./BrandSettingsView.vue?vue&type=template&id=61044132&scoped=true&"
import script from "./BrandSettingsView.vue?vue&type=script&lang=js&"
export * from "./BrandSettingsView.vue?vue&type=script&lang=js&"
import style0 from "./BrandSettingsView.vue?vue&type=style&index=0&id=61044132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61044132",
  null
  
)

export default component.exports